import { render, staticRenderFns } from "./AddCost.vue?vue&type=template&id=47bd31ba&scoped=true&"
import script from "./AddCost.vue?vue&type=script&lang=js&"
export * from "./AddCost.vue?vue&type=script&lang=js&"
import style0 from "./AddCost.vue?vue&type=style&index=0&id=47bd31ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd31ba",
  null
  
)

export default component.exports